<template>
    <div>
        <Cafe24AppHome/>
    </div>
</template>

<script>
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';
    import Cafe24AppHome from '@/components/cafe24/Cafe24AppHome';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'Cafe24DashboardView',
        components: {Cafe24AppHome},
        data() {
            return {
                isShowInit: false,
                isInitLoading: false,

                isProductLoading: false,
                productList: [],

                isArtLoading: false,
                artId: '',
                artList: [],
            };
        },
        computed: {
            mall() {
                return this.$store.state.cafe24.mall;
            },
            authToken() {
                return this.$store.state.auth.authToken;
            },
            isAdmin() {
                return this.$store.state.auth.partner.isAdmin;
            },
        },
        methods: {
            async getArt() {
                try {
                    this.isArtLoading = true;
                    const {data: art} = await PrintingDiyRepository.getPartnerArt(this.mall.mallId, this.artId, this.authToken);
                    this.artList.push(art);
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.artId = '';
                    this.isArtLoading = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

</style>